'use strict';

function repeatString(str, num) {
  var result = '';
  str = str.toString();
  while (num > 0) {
    if (num & 1) {
      result += str;
    }
    if (num >>= 1) {
      str += str;
    }
  }
  return result;
}

module.exports = repeatString;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/repeatString.js
// module id = 91
// module chunks = 0